import type { HomeHighlightItemProps } from '@/repositories/home/HomeRepository.types';
import { Content } from '@/modules/Entertainment/interface/Content';
import { PATHS } from '@/config/paths';

export const mountHighlightCardLink = (highlight: HomeHighlightItemProps) => {
  if (highlight?.type === 'external') {
    return setHrefByType(highlight);
  }

  if (highlight?.cta_link) {
    return String(highlight?.cta_link) || '#';
  }

  return setHrefByType(highlight);
};

const setHrefByType = (highlight: HomeHighlightItemProps): string =>
  ({
    author: `${PATHS?.hubs?.author}/${highlight?.author?.slug || highlight?.author?.id}`,
    content: `${PATHS?.hubs?.content}/${highlight?.content?.slug}`,
    external: String(highlight?.destination_link) || '#',
    program: `${PATHS?.hubs?.program}/${highlight?.program?.slug}`,
  })[highlight.type];

const recentContentsTypeMap: Record<string, string> = {
  content: PATHS?.hubs?.content,
  program: PATHS?.hubs?.program,
  researchProgram: PATHS?.hubs?.researchProgram,
};

export const getHrefRecentContent = ({
  object,
  program_type,
  slug,
}: Pick<Content, 'object' | 'program_type' | 'slug'>) => {
  if (object === 'content') {
    return recentContentsTypeMap['content'] + `/${slug}`;
  }

  const isRecommendation = program_type === 'recommendation';
  const type = isRecommendation ? 'researchProgram' : object;

  return recentContentsTypeMap[type] + `/${slug}` || '#';
};

export const contentTypeByURLType = {
  content: 'conteudo',
  contents: 'conteudo',
  default: 'conteudo',
  interview: 'conteudo',
  movie: 'conteudo',
  video: 'conteudo',
  event: 'eventos',
  events: 'eventos',
  course: 'programa',
  journey: 'programa',
  podcast: 'programa',
  program: 'programa',
  programs: 'programa',
  recommendation: 'programa',
  series: 'programa',
  tutorial: 'programa',
  analyst: 'autor',
  author: 'autor',
  autor: 'autor',
  journeyhome: 'jornadas',
  coursehome: 'cursos',
  entertainmenthome: 'filmes',
  research: 'research',
  investing: 'investir',
  news: 'noticias',
  newshome: 'noticias',
  recommended: 'ativos-recomendados',
  profile: 'meu-perfil',
  user: 'meu-usuario',
  historicuserciew: 'meu-historico',
  historicuserview: 'meu-historico',
  lives: 'ao-vivo',
  wallet: 'minha-carteira',
  businesscredit: 'credito-empresarial',
  exchange: 'cambio',
  freeenegymarket: 'mercado-livre-energia',
  homeequity: 'home-equity',
  lifeinsurance: 'seguro-vida',
  realstatefinancing: 'financiamento-imobiliario',
  consortium: 'consorcio',
  pension: 'previdencia',
  creditcard: 'cartao-de-credito',
} as const;

export type ContentTypeByURLType = keyof typeof contentTypeByURLType;
